import { getLocalDateKey } from './activity.js';

const isDateKey = (value) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
  const [year, month, day] = value.split('-').map(Number);
  return getLocalDateKey(new Date(year, month - 1, day)) === value;
};

export const readActivityReportLink = (search = '') => {
  const params = new URLSearchParams(search);
  const child = params.get('child');
  const start = params.get('start');
  const end = params.get('end');
  return {
    child: child && child.length <= 128 ? child : 'all',
    range: isDateKey(start) && isDateKey(end) && start <= end ? { startDate: start, endDate: end } : null,
  };
};

export const buildActivityReportLink = (child, range) => {
  const params = new URLSearchParams({ child, start: range.startDate, end: range.endDate });
  return `/parent/transactions?${params.toString()}`;
};
